<template>
  <SpringPopup
    class="app-popup-confirm-submit text-center"
    max-width="max-w-600"
    border-radius="rounded-6"
  >
    <div class="app-popup-confirm-submit__text mb-30">
      One or more of your documents failed to upload, are you sure you want to continue
    </div>

    <transition
      name="fade"
      mode="out-in"
    >
      <div class="app-popup-confirm-submit__container">
        <AppButton
          class="app-popup-confirm-submit__button"
          :theme="theme"
          @click="$emit('try-again')"
        >
          No, I Want to Try Again
        </AppButton>
        <AppButton
          class="app-popup-confirm-submit__button-clear"
          :shadow-button="false"
          :color-text="true"
          :theme="theme"
          :class="[borderColorClass()]"
          @click="$emit('continue')"
        >
          Yes, I Want to Continue
        </AppButton>
      </div>
    </transition>
  </SpringPopup>
</template>

<script>
import { SpringPopup } from 'spring-ui'
import AppButton from '@/components/common/buttons/AppButton'
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppPopupConfirmSubmit',

  // Components
  components: {
    SpringPopup,
    AppButton
  },

  mixins: [theme]
}
</script>

<style scoped lang="scss">

.fade-enter-active,
.fade-leave-active {
  transition: opacity 250ms ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.app-popup-confirm-submit {
  &__text {
    @apply text-base;

    @screen sm {
      @apply text-lg;
    }
  }

  &__container {
    @apply mb-6 flex justify-between flex-col;
  }

  &__button {
    @apply my-3;
  }

  &__button-clear {
    @apply bg-white my-3 border-2;
  }
}
</style>
